import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      nav("/login");
    } catch (ex) {
      setErr(formatApiErrorDetail(ex?.response?.data?.detail) || ex.message);
    } finally { setBusy(false); }
  };

  return (
    <main className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4" data-testid="reset-page">
      <div className="w-full max-w-md glass rounded-3xl p-8 rise">
        <h1 className="font-display text-2xl font-bold mb-2">Set a new password</h1>
        {!token ? (
          <p className="text-sm text-red-400">Invalid reset link.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-3">
            <div><Label>New password</Label><Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="bg-slate-900 border-slate-800 mt-1.5 h-11" /></div>
            {err && <p className="text-sm text-red-400">{err}</p>}
            <Button type="submit" disabled={busy} data-testid="reset-submit" className="w-full h-11 bg-white text-slate-950 hover:bg-slate-100 font-semibold">{busy ? "Saving…" : "Set password"}</Button>
          </form>
        )}
        <p className="mt-5 text-center text-sm"><Link to="/login" className="text-cyan-400 hover:text-cyan-300">← Back to sign in</Link></p>
      </div>
    </main>
  );
}
